import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-camera-permissions',
  templateUrl: './camera-permissions.component.html',
  styleUrls: ['./camera-permissions.component.scss']
})
export class CameraPermissionsComponent implements OnInit {
  selectedInstructionsType: 'mobile' | 'desktop' | 'pwa' | null = null;
  currentSiteUrl: string = window.location.origin;
  constructor(
  ) {}

  ngOnInit() {
    this.setInitialInstructionsType();
  }

  private setInitialInstructionsType(): void {
    this.selectedInstructionsType = this.isMobileDevice() ? 'mobile' : 'desktop';
  }

  isMobileDevice(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;

    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  }

  isIOS(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;

    return /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
  }

  isAndroid(): boolean {
    const userAgent = navigator.userAgent;

    return /Android/i.test(userAgent);
  }

  detectDesktopBrowser(): 'chrome' | 'firefox' | 'safari' | 'edge' | 'other' {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('chrome') && !userAgent.includes('edge')) {
      return 'chrome';
    } else if (userAgent.includes('firefox')) {
      return 'firefox';
    } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
      return 'safari';
    } else if (userAgent.includes('edge')) {
      return 'edge';
    }

    return 'other';
  }

  detectMobileBrowser(): 'chrome-android' | 'safari-ios' | 'firefox-mobile' | 'samsung-internet' | 'other-mobile' {
    const userAgent = navigator.userAgent.toLowerCase();

    if (this.isIOS()) {
      return 'safari-ios';
    } else if (this.isAndroid()) {
      if (userAgent.includes('chrome') && !userAgent.includes('chromium') && !userAgent.includes('samsungbrowser')) {
        return 'chrome-android';
      } else if (userAgent.includes('firefox')) {
        return 'firefox-mobile';
      } else if (userAgent.includes('samsungbrowser')) {
        return 'samsung-internet';
      }
    }

    return 'other-mobile';
  }
}
